import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  border-top: 1px solid ", ";\n  color: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  height: 2.14em;\n  line-height: 2.14;\n  margin-bottom: 0.28em;\n  padding: 0 12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { color, typography } from '@scp/ui-shared/theme/variables';
var Heading = styled.div(_templateObject(), color.backgroundSecondary, color.border, color.border, color.textPrimary, typography.fontWeightSemiBold);
export var GroupHeading = function GroupHeading(_ref) {
  var children = _ref.children,
      id = _ref.id;
  return React.createElement(Heading, {
    id: id
  }, children);
};